export const MAX_PANEL_WIDTH = 1120;
export const MEDIUM_PANEL_WIDTH = 736;
export const MEDIUM_PANEL_RELATIVE_WIDTH = 0.4;
export const SMALL_PANEL_WIDTH = 440;
export const SMALL_PANEL_RELATIVE_WIDTH = 0.25;
